// react-frontend/src/cable.js
import { createConsumer } from '@rails/actioncable';

const URL = "/websocket";
const consumer = createConsumer(URL);

export default consumer;
